import { createContext, useContext, type PropsWithChildren } from "react";
import type { Actor } from "@corpuscomplete/core/actor";

export namespace CurrentActor {
  const Context = createContext<Actor | null>(null);

  export function Provider({ actor, children }: PropsWithChildren<{ actor: Actor }>) {
    return <Context.Provider value={actor}>{children}</Context.Provider>;
  }

  export function use(): Actor {
    const value = useContext(Context);
    if (!value) {
      throw new Error("CurrentActor.use() must be used within CurrentActor.Provider");
    }
    return value;
  }
}
